import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const SummaryBox = ({ title, items, TitleIcon, RowIcon, rowIconColor }) => (
  <Styles.Container>
    <Styles.Header>
      {TitleIcon && <TitleIcon size={16} />}
      <Text type="titleS">{title}</Text>
    </Styles.Header>
    <Styles.ItemsList>
      {items.map(item => (
        <Styles.Item key={item.id}>
          {RowIcon && <RowIcon size={16} color={rowIconColor} />}
          <Text type="bodySRegular">{item.name}</Text>
        </Styles.Item>
      ))}
    </Styles.ItemsList>
  </Styles.Container>
)

export default SummaryBox
